module.exports = __webpack_public_path__ + "img/Supporting-Women-Empowerment-1110x450.cb73d9be.png";